import { InferType } from 'yup'
import { masonryGalleryBlockSchema } from './masonryGalleryBlockSchema'
import { ELayoutGroupType } from '../meta/ELayoutGroupType'
export const masonryGallery2BlockSchema = masonryGalleryBlockSchema.meta({
  layoutGroupType: ELayoutGroupType.CARDS,
})

export type MasonryGallery2Block = InferType<typeof masonryGallery2BlockSchema>
